var React = require('react');

function Dock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.22727 1.72727V17.2727H16.7727V1.72727H1.22727ZM16.883 1.72795C16.883 1.72796 16.8834 1.72807 16.883 1.72795V1.72795ZM1.11702 17.272C1.11661 17.2719 1.11702 17.272 1.11702 17.272V17.272ZM1.11702 1.72795C1.11658 1.72803 1.11702 1.72794 1.11702 1.72795V1.72795ZM1.125 0.5C0.50368 0.5 0 0.947716 0 1.5V17.5C0 18.0523 0.50368 18.5 1.125 18.5H16.875C17.4963 18.5 18 18.0523 18 17.5V1.5C18 0.947715 17.4963 0.5 16.875 0.5H1.125Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M11.25 3.5C11.25 3.08579 11.5858 2.75 12 2.75H15C15.4142 2.75 15.75 3.08579 15.75 3.5V15.4998C15.75 15.914 15.4142 16.2498 15 16.2498H12C11.5858 16.2498 11.25 15.9141 11.25 15.4998V3.5Z","fill":"currentColor","key":1})]);
}

Dock.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = Dock;

Dock.default = Dock;
